const features = [
  "Expert medical guidance with seamless digital access.",
  "Holistic insights through consolidated health reports.",
  "Patient-first experience that prioritizes clarity and convenience.",
  "Secure and confidential handling of your medical information.",
  "Integrated ecosystem combining care, diagnostics, and wellness.",
];

export default function WhyChoose() {
  return (
    <section className="py-20 bg-muted/40">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-semibold text-foreground">
          Why Choose Medigenix?
        </h2>

        <ul className="mt-6 space-y-3">
          {features.map((f, i) => (
            <li key={i} className="text-muted-foreground">
              • {f}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
